import React, { useState } from "react";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import useCrypto from "../../../customHooks/crypto";
import { getPreSignedUrl, uploadFileToS3 } from "../../AxiosRtk/Miscellaneous";
import { addNewKid, setNewKidData } from "../../AxiosRtk/AddNewChild";
import { AlertModal } from "../../../../setup/alert/swalAlert";
import { alertIconType } from "../../../../setup/alert/iconTypes";
import { isSpecialCharContains } from "../../../../utils/specialCharCheck";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { kidList, setKidList } from "../../AxiosRtk/DashBoard";
import useKidListFunctionality from "../../../customHooks/kidListHook";

const AddNewChild = ({ getLangTranslation }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { encodeNumberToBase64 } = useCrypto();
  const { user: userData } = useSelector(({ auth }) => auth);
  const [kidData, setKidData] = useState({
    childName: { value: "", error: "", errVal: "" },
    gender: { value: "Male", error: "", errVal: "" },
    dob: { value: "", error: "", errVal: "" },
    image: {
      file: null,
      childPicUrl: "",
      error: "",
      errVal: "",
    },
  });
  const [presigned, setPresignedData] = useState(null);
  const { getImage } = useKidListFunctionality();
  const fiveYearsBack = () => {
    const todayDateString = new Date();
    var d = new Date(moment(todayDateString).locale("en").format("DD-MM-YYYY"));
    d.setFullYear(d.getFullYear() - 5);
    return d;
  };

  const handleImageUpload = async (event) => {
    // new image upload code start-------------------------------------------------------------
    const payload = {
      type: "put",
      fileName: event.target.files[0].name,
    };
    try {
      getPreSignedUrl(payload)
        .then((res) => {
          setPresignedData(res?.data?.result);
        })
        .catch((err) => {
          console.log(
            "catch error presigned url ==>>",
            err?.response?.data?.message
          );
        });
    } catch (error) {
      console.log(error);
    }

    // new image upload code end-------------------------------------------------------------
    setKidData({
      ...kidData,
      image: {
        file: event.target.files[0],
        childPicUrl: URL.createObjectURL(event.target.files[0]),
        error: "",
      },
    });
  };

  function handleInputChange(e) {
    const { name, value } = e.target;
    setKidData({
      ...kidData,
      [name]: {
        value,
        error: "",
      },
    });
  }

  function addNewChildApi(payload) {
    addNewKid(payload)
      .then((res) => {
        dispatch(setNewKidData(res?.data?.result));
        kidList()
          .then((res) => {
            dispatch(setKidList(res?.data?.result));
          })
          .catch((err) => {
            console.log(
              "kid list catch error ==>>",
              err?.response?.data?.message
            );
          })
          .finally(() => { });
      })
      .catch((err) => {
        AlertModal(
          err?.response?.data?.message,
          alertIconType?.errorIcon,
          true
        );
      });
  }

  function validateForm() {
    let flag = true;
    const kidDataTemp = { ...kidData };
    if (!kidData?.childName?.value) {
      // check if child name is blank
      flag = false;
      kidDataTemp["childName"]["value"] = "";
      kidDataTemp["childName"]["error"] = "CHILDNAME_IS_REQUIRED";
      kidDataTemp["childName"]["errVal"] = "Child name is required";
    } else if (
      kidData?.childName?.value &&
      isSpecialCharContains(kidData?.childName?.value)
    ) {
      // Check if child name contains any special characters
      flag = false;
      kidDataTemp["childName"]["value"] = kidData?.childName?.value;
      kidDataTemp["childName"]["error"] = "SPECIAL_CHAR_NOT_ALLOWED_ERR";
      kidDataTemp["childName"]["errVal"] = "Special characters are not allowed";
    }

    if (!kidData?.dob?.value) {
      flag = false;
      kidDataTemp["dob"]["value"] = kidData?.dob?.value;
      kidDataTemp["dob"]["error"] = "CHILD_DOB_ERR";
      kidDataTemp["dob"]["errVal"] = "Please select child date of birth";
    }

    setKidData(kidDataTemp);
    return flag;
  }

  function handleSaveData() {
    if (!validateForm()) {
      return;
    }

    try {
      let formattedDob = moment(kidData?.dob?.value).format("DD-MM-YYYY");

      if (!kidData?.image?.file) {
        const payload = {
          childName: kidData?.childName?.value,
          childPic: "NaN",
          dob: formattedDob, // Use the formatted date
          gender: kidData?.gender?.value,
        };
        addNewChildApi(payload);
      } else {
        // s3 upload new format start
        uploadFileToS3(
          `${presigned?.signedUrlForPutObject}`,
          kidData?.image?.file,
          {
            "Content-Type": kidData?.image?.file.type,
            version_code: 20000,
          }
        )
          .then((res) => {
            const payload = {
              childName: kidData?.childName?.value,
              childPic: `${process.env.REACT_APP_IMAGE_BUCKET_PHASE2_DEV
                }/${encodeNumberToBase64(userData?.ID)}/ProfilesPics/${kidData?.image?.file?.name
                }`,
              dob: formattedDob, // Use the formatted date
              gender: kidData?.gender?.value,
            };
            addNewChildApi(payload);
          })
          .catch((error) => {
            console.log("upload to s3 catch error ==>>", error?.response);
          });
      }
    } catch (e) {
      console.log(e);
    }
  }


  const genderOptions = [
    {
      label: getLangTranslation("EDIT_PROFILE_MALE", "Male"),
      value: "Male",
    },
    {
      label: getLangTranslation("EDIT_PROFILE_FEMALE", "Female"),
      value: "Female",
    },
  ];

  return (
    <div className="card">
      <div className="card-body px-9-md py-9-md p-6">
        <div className="content-550 mx-auto">
          <h2 className="text-center mb-3">
            {getLangTranslation("PARENT_DASHBOARD_ADD_A_CHILD", "Add a child")}
          </h2>
          <p className="text-center mb-6 light-text">
            {getLangTranslation(
              "PLEASE_ENTER_YOUR_CHILD_DETAILS_TITLE",
              "Please enter your child`s details"
            )}
          </p>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="image-placeholder add-image ratio ratio-1x1 mb-3">
              <img
                src={
                  kidData?.image?.childPicUrl
                }
                alt="Child Pic"
                className="rounded-circle"
                onError={(event) => {
                  event.target.onerror = null;
                  event.target.src = event.target.src = getImage(
                    "",
                    kidData?.gender?.value
                  );
                }}
              />
            </div>
            <button className="btn btn-outline-primary custom-file-wrap d-inline-flex align-items-center gap-1 mb-6">
              <i className="icon-plus fs-6" />
              {getLangTranslation("ADD_CHILD_AVATAR_TITLE", "Add child Avatar")}
              <input
                name="childPic"
                onChange={handleImageUpload}
                type="file"
                accept=".png, .jpg, .jpeg, .svg"
              />
            </button>
          </div>
          <div className="mb-6">
            <label htmlFor="childName" className="form-label">
              {getLangTranslation("ADD_CHILD_FULL_NAME", "Full name")}
            </label>
            <input
              type="text"
              className="form-control"
              id="childName"
              placeholder={getLangTranslation(
                "ADD_CHILD_FULL_NAME",
                "Full name"
              )}
              name="childName"
              onChange={handleInputChange}
            />
            {kidData?.childName?.error && (
              <label className="field-error">
                {getLangTranslation(
                  kidData?.childName?.error,
                  kidData?.childName?.errVal
                )}
              </label>
            )}
          </div>
          <div className="mb-6">
            <label htmlFor="gender" className="form-label">
              {getLangTranslation("ADD_CHILD_GENDER", "Gender")}
            </label>
            <Select
              className="custom-select"
              classNamePrefix="custom-select"
              placeholder="Select"
              onChange={(val) =>
                setKidData({
                  ...kidData,
                  gender: {
                    value: val.value,
                    error: "",
                  },
                })
              }
              options={genderOptions}
              value={
                genderOptions?.find(
                  (item) => item?.value === kidData?.gender?.value
                ) || ""
              }
            />
          </div>
          <div className="mb-6">
            <label className="form-label">
              {getLangTranslation("ADD_CHILD_AGE", "Age")}
            </label>
            <input
              type="date"
              id="basic-datepicker"
              className="form-control"
              name="dob"
              value={kidData?.dob?.value}
              max={moment(fiveYearsBack())
                .locale("en")
                .toString()}
              onChange={handleInputChange}
            />
            {kidData?.dob?.error && (
              <label className="field-error">
                {getLangTranslation(kidData?.dob?.error, kidData?.dob?.errVal)}
              </label>
            )}
          </div>
          <div className="grid gap-3">
            <button
              className="btn btn-outline-primary g-col-6"
              type="button"
              onClick={() => history.push("/dashboard")}
            >
              <span className="btn-upper-case">
                {getLangTranslation(
                  "CHILD_NOTIFICATION_FILTER_BUTTON_CANCEL",
                  "Cancel"
                )}
              </span>
            </button>
            <button
              className="btn btn-primary g-col-6"
              type="button"
              onClick={handleSaveData}
            >
              <span className="btn-upper-case">
                {getLangTranslation(
                  "CHILD_DETAIL_PENDING_DEVICE_BUTTON_CONTINUE",
                  "Continue"
                )}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewChild;
